<script lang="ts">
  import type { Country, Order } from '../../api'
  import { handleCurrencySign } from '../../helpers'

  export let order: Order
  export let userCountry: Country

  const currency = handleCurrencySign(userCountry)
  const paymentDetails = order.payment?.paymentMethod?.card
  const orderInventory = order.products[0].inventory
  const completedAt = new Date(order.completedAt)
  const updatedAt = new Date(order.updatedAt)
  const expiresAt = new Date(order.completedAt)
  expiresAt.setFullYear(completedAt.getFullYear() + 1)
  const isCanceled = order.state === 'CANCELLED'
  const isUpgrade = order.type === 'hdcMembershipUpgrade'
  const refundAmount = order.payment && order.payment.totalRefundAmount ? order.payment.totalRefundAmount : null

  $: orderAction = isUpgrade ? 'Upgrade' : (orderInventory.isVip ? 'Redeem' : 'Purchase')
  $: canceledAt = updatedAt.toLocaleDateString() + ' ' + updatedAt.toLocaleTimeString()
  const localeOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
  }
  const money = (v: number) => (v / 100).toFixed(2)
  $: brand = paymentDetails?.brand?.toUpperCase()
</script>

<style>
  p {
    margin: 0;
  }
</style>

<p data-test="order-desc">
  {completedAt.toLocaleDateString('en', localeOptions).replace(',', '')} {orderInventory.name} {orderAction}
</p>
<p data-test="order-subtotal">
  Subtotal: {currency}{money(orderInventory.priceCents.amount)}
  {#if orderInventory.priceCents.amount !== order.payment.totalAmount}
    - Credit: {currency}{money(orderInventory.priceCents.amount - order.payment.totalAmount)}
  {/if}
</p>
{#if paymentDetails}
  <p data-test="order-payment">
    Paid {currency}{money(order.payment.totalAmount)}, {brand}: •••• {paymentDetails.last4}
  </p>
{/if}
{#if isCanceled}
  <p data-test="order-cancellation">
    Cancelled: {canceledAt}, Refunded: {currency}{money(order.payment.totalRefundAmount)}
  </p>
{/if}
{#if refundAmount}
  <p data-test="order-refund">
    Refund amount: {currency}{money(refundAmount)}
  </p>
{/if}
